module.exports = __webpack_public_path__ + "img/185.6bbcf170.jpg";